var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-thumbnail",class:_vm.imgClass},[_c('img',{ref:"image",class:{ pointer: _vm.openLink },style:({ transform: _vm.transform }),attrs:{"src":_vm.imgSrc,"alt":_vm.imgAlt},on:{"click":_vm.viewOriginal}}),_vm._v(" "),(_vm.openLink)?_c('i',{staticClass:"fas fa-external-link-alt"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }